// {Dashboard.tsx}

import { Box } from '@mui/material';
import React from 'react';
import { useMsal } from '@azure/msal-react';
import { closeAssay, Dashboard as DashboardContent, ResourceType, TrackedAction, useAppDispatch } from 'quil';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
// import useStyles from './styles';
// import TEST_ID from './constants';

export interface DashboardProps {
  // Props
}

export default function Dashboard() {
  // const { classes, cx } = useStyles();
  const {keycloak} = useKeycloak();
  const firstName = keycloak.profile?.firstName;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleNav = (navTo: string) => {
    navigate(navTo);
  };

  const handleNavToRecent = (action: TrackedAction) => {
    
    if (action.resourceType === ResourceType.Experiment){
      dispatch(closeAssay());
      navigate('experiments/editor', { state: { experimentId: action.resourceId } });
    }
    else if (action.resourceType === ResourceType.Assay){
  dispatch(closeAssay());
      navigate('assays/editor', { state: { protocolId: action.resourceId } });
    } 
  }

  return (
    <Box>
      <DashboardContent userFirstName={firstName || ''} onNavTo={handleNav} onRecentClick={handleNavToRecent} />
    </Box>
  );
}
